import * as React from 'react'
import ButtonPill from 'ui/atoms/ButtonPill'

function QuestionTypeItem({
  id,
  idForBuilder,
  name,
  onClick,
  disabled = false,
}) {
  const onClickType = React.useCallback(() => {
    if (disabled) return
    onClick(idForBuilder, id)
  }, [idForBuilder, id, onClick, disabled])

  return (
    <ButtonPill
      dataCy={'question-type-' + name.toLowerCase().replace(/ /g, '-')}
      disabled={disabled}
      onClick={onClickType}
    >
      {name}
    </ButtonPill>
  )
}

export default QuestionTypeItem
